import HtmlEditor, { HtmlEditorProps } from './HtmlEditor';

export type { HtmlEditorProps };
export default HtmlEditor;
